<template>
  <el-select style="width: 100%" v-bind="$props" @input="handleInput" filterable>
    <el-option v-for="opt in options" :key="opt.code" :value="opt.code" :label="opt.name"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "RoleSelect",
    props: {
      value: {},
      multiple: Boolean,
      filterable: Boolean,
      clearable: Boolean,
      placeholder: String,
    },
    computed: {
      options() {
        return this.$store.state.options.roles;
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
      }
    },
    created() {
      this.$store.commit('initRoles')
    },
  }
</script>

<style scoped>

</style>
